module.exports = __webpack_public_path__ + "static/celebrate_health-a69d8c0c5c3188353ed428f6620347d6.png";